@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <div class='text-list-input-container'>
      <label>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </label>
      @if (inputService.inputConfig.hint) {
        <span class='text-list-input-hint'>{{inputService.inputConfig.hint | translate}}</span>
      }
      <div class='text-list-input-items'>
        @for (item of list; track trackByFn(i, item); let i = $index) {
          <mat-form-field class='text-list-input-item'>
            <input [readonly]='inputService.inputConfig.readOnly' matInput autocomplete="off" [name]='inputService.formControlKey + "text_input_item_" + i' [(ngModel)]='list[i]' [ngModelOptions]="{standalone: true}"/>
            @if (!inputService.inputConfig.readOnly) {
              <button mat-icon-button matIconSuffix color='warn' (click)="removeItem(i)">
                <span class="material-icons">close</span>
              </button>
            }
          </mat-form-field>
        }
      </div>
      @if (!inputService.inputConfig.readOnly) {
        <button mat-button color='accent' (click)='addNewItem()'>{{'Aggiungi' | translate}}</button>
      }
    </div>
  </ng-container>
}